import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 10px;
`

export const Title = styled.h2`
  font-size: 16px;
  font-weight: 500;
  margin: 7px 0px 5px;
  align-self: center;
`
